import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "bulk-upload-jail-calls",
  courseId: "investigations",
  order: 2,
  title: "Upload jail calls",
  subtitle: "Bulk upload",
  summary:
    "If you have a month of calls to load, drop them all at once. Duplicates are refused before any bytes move, the batch survives navigation, and every call is transcribed, translated when needed, and analyzed.",
  learn: [
    "Upload many calls in one batch",
    "Understand duplicate detection and privileged marking",
    "Import from your cases or Axon instead of your disk",
  ],
  minutes: 4,
  releasedAt: "2026-08-24T00:00:00.000Z",
  gate: "investigations",
  body: [
    {
      type: "steps",
      items: [
        "Open the investigation's Files tab and drop the files on the zone, or click to pick them. Audio, PDFs, spreadsheets, Word documents, photos, and video are all accepted.",
        "Leave the page if you need to. The batch keeps going and shows progress when you return.",
        "To mark a call privileged, open its row and choose mark privileged.",
        "To pull in material you already have in the app, use \"Import from your cases\" and choose Case uploads, My reports (your own narratives as PDFs), or Bodycam (Axon) footage.",
      ],
    },
    {
      type: "paragraph",
      text: "Each file is fingerprinted in your browser before it uploads. A file already in this investigation is reported as a duplicate and skipped, so you can re-drop an overlapping folder without paying for it twice. A call marked privileged has its content removed from analysis and chat. The file and audio stay for chain of custody.",
    },
    { type: "heading", text: "What happens to each call" },
    {
      type: "paragraph",
      text: "Each call is transcribed with speaker separation. Language is identified automatically and translated to English when needed. The recorded preamble is detected so it is not analyzed as conversation. The full transcript is then read for relevance, leads, entities, and slang. Filenames in the jail system's format are parsed for date, time, and PIN.",
    },
    {
      type: "callout",
      tone: "note",
      title: "Hours, not files",
      text: "Your department's allowance is pooled across all investigators and metered in minutes of audio. You will not see a running count, but the Files tab warns when most or all of the department's hours for the period are used. Admins can add hour packs.",
    },
    {
      type: "callout",
      tone: "tip",
      text: "Upload in chronological batches. Each new batch is analyzed with what earlier files established, so names and places in later calls resolve against the people the AI already knows.",
    },
    {
      type: "paragraph",
      text: "Once the first batch finishes, Leads queue covers what to do with the flags it produced.",
    },
  ],
  related: ["create-an-investigation", "calls-and-transcripts", "documents-spreadsheets-photos"],
};

export default lesson;
